import { Button } from "@components/ui/button";

export function WelcomeScreen({ onDone }: { onDone: () => void }) {
  return (
    <div className="fixed inset-0 z-[120] overflow-hidden bg-black text-white">
      <img
        src="/background.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/55 to-black/80"
      />

      <div className="relative z-10 mx-auto flex min-h-dvh w-full max-w-md flex-col px-6 pt-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.25rem,env(safe-area-inset-bottom))]">
        <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-8 overflow-y-auto py-6 text-center">
          <img
            src="/icons/icon.svg"
            alt="Komut"
            width={96}
            height={96}
            className="h-24 w-24 drop-shadow-[0_20px_45px_rgba(16,185,129,0.35)]"
          />

          <div className="space-y-3">
            <h1 className="font-outfit text-[clamp(1.75rem,7vw,2.25rem)] font-black leading-tight tracking-tight text-white">
              Welcome to Komut
            </h1>
            <p className="text-[17px] font-medium leading-relaxed text-white/80">
              Connect with people going your way. Keep your daily commute more
              social, affordable, and enjoyable.
            </p>
          </div>
        </div>

        <div className="mt-6 flex shrink-0 flex-col items-center gap-5">
          <Button
            type="button"
            className="h-12 w-full rounded-2xl bg-emerald-500 text-base font-semibold text-white hover:bg-emerald-500/90"
            onClick={onDone}
          >
            Get Started
          </Button>
        </div>
      </div>
    </div>
  );
}
